import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import "./index.scss";

import React from "react";
import { ModalsContextProvider } from "./context/modals.context";
import "./i18n";
import { AuthContextProvider } from "./modules/auth/auth.context";
import { ZAMPublic } from "./pages/ZAMPublic/ZAMPublic";
import { WithAxios } from "./utils/axios";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const isPublicApp = process.env.REACT_APP_IS_PUBLIC;

if (isPublicApp) {
  root.render(
    <ModalsContextProvider>
      <WithAxios>
        <ZAMPublic />
      </WithAxios>
    </ModalsContextProvider>
  );
} else {
  root.render(
    <React.StrictMode>
      <AuthContextProvider>
        <ModalsContextProvider>
          <WithAxios>
            <BrowserRouter >
              <App />
            </BrowserRouter>
          </WithAxios>
        </ModalsContextProvider>
      </AuthContextProvider>
    </React.StrictMode>
  );
}
